"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _style = require("./style");
var _SecurityLockIcon = _interopRequireDefault(require("./SecurityLockIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function BannedUserMessage(_ref) {
  var partnerName = _ref.partnerName,
    onPress = _ref.onPress,
    isAdview = _ref.isAdview;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    isAdview: isAdview,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.MainWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SecurityLockIcon["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Header, {
        children: "Usu\xE1rio Bloqueado"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Body, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.UserName, {
          children: partnerName
        }), " apresentou um comportamento suspeito e, por isso, bloqueamos este usu\xE1rio. Desejamos que voc\xEA tenha apenas contatos confi\xE1veis na plataforma. \uD83D\uDC9C"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.FooterWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Footer, {
        children: "Se quiser saber mais sobre porque est\xE1 vendo esta tela,"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Footer, {
        children: [" acesse nosso site sobre ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.HelpCenterLink, {
          onClick: onPress,
          onPress: onPress,
          children: "Seguran\xE7a na OLX"
        }), "."]
      })]
    })]
  });
}
BannedUserMessage.propTypes = {
  onPress: _propTypes.func.isRequired,
  partnerName: _propTypes.string.isRequired,
  isAdview: _propTypes.bool
};
var _default = exports["default"] = BannedUserMessage;